import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classcat';
import Bingo from 'modules/Bingo';
import SpriteIcon from './SpriteIcon';

const { GAME_TYPE } = Bingo.constants;

// TODO: This is hilariously unoptimized
const GameBoard = ({ rows, dropped, type, purchased, selected, pictureNumbersImageUrl }) => (
  <div className="ticket__gameBoard">
    {rows &&
      rows.map((row, i) => {
        const flipCounter =
          row &&
          row.positions &&
          row.positions.reduce((prev, position) => {
            const called = dropped && dropped.length > 0 && dropped.includes(position.value);
            const star = position.free === true;
            if (called || star) {
              return prev + 1;
            } else {
              return prev;
            }
          }, 0);
        return (
          <div className={`ticket__row row ${flipCounter === 9 ? 'winner' : ''}`} key={i}>
            {row &&
              row.positions &&
              row.positions.map((position) => {
                const called = dropped.length > 0 && dropped.includes(position.value);
                const star = position.free === true;
                const cellClass = classNames([
                  {
                    ticket__cell: true,
                    [`ticket__cell--${type}`]: type,
                    inPattern: position.partOfPattern,
                    notInPattern: !position.partOfPattern,
                    inPlay: position.value !== null,
                    star: star,
                    called: called
                  }
                ]);
                return (
                  <div key={position.index} className={cellClass}>
                    <span className="ticket__cell-value">
                      {type === GAME_TYPE['30'] ? (
                        <SpriteIcon
                          src={pictureNumbersImageUrl}
                          value={position.value}
                          disabled={
                            (dropped.length > 0 && !called) || !(purchased || selected || called)
                          }
                        />
                      ) : (
                        position.value
                      )}
                    </span>
                  </div>
                );
              })}
          </div>
        );
      })}
  </div>
);

GameBoard.propTypes = {
  type: PropTypes.oneOf(['30', '75', '90']),
  purchased: PropTypes.bool,
  selected: PropTypes.bool,
  rows: PropTypes.arrayOf(PropTypes.object),
  dropped: PropTypes.arrayOf(PropTypes.number),
  pictureNumbersImageUrl: PropTypes.string
};

GameBoard.defaultProps = {
  purchased: false,
  selected: false,
  type: null,
  rows: [],
  dropped: [],
  pictureNumbersImageUrl: null
};

export default GameBoard;
